import React from "react";
import Label from "./Label";
import * as Const from "./../_Const";

const Input = ({
  value,
  onChange,
  name,
  label,
  autoComplete,
  type = "text",
  errorMessage,
  showLabel = true,
  readOnly = false,
  maxLength = 524288,
  showClearIcon = false,
  onClear,
}) => {
  const isError = errorMessage ? true : false;
  const errorClass = isError ? "border-error-dark" : "border-accent";
  const isTerminal = Const.isTerminal();

  const textClass = isTerminal ? "text-4xl h-20" : "h-10 bg-white";
  const clearCss = showClearIcon && onClear ? "pl-4 pr-12" : "p-4";
  const clearColorCss = isError ? "fill-error-dark" : "fill-accent-dark";
  return (
    <div className="flex flex-col">
      <Label name={name} errorMessage={errorMessage} label={label} showLabel={showLabel} />
      <div className="relative">
        <input
          type={type}
          name={name}
          id={name}
          maxLength={maxLength}
          readOnly={readOnly}
          onChange={onChange}
          value={value}
          placeholder={`Vyplňte ${label}`}
          autoComplete={autoComplete}
          className={`border rounded-xl ${textClass} w-full ${clearCss} text-input inset-shadow-xl focus:outline-none  focus:bg-accent-secondarya selection:bg-accent-secondary selection:text-black ${errorClass}`}
        />
        {showClearIcon && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={onClear}>
            <svg xmlns="http://www.w3.org/2000/svg" className={`${clearColorCss}`} width="29.25" height="29.25" viewBox="0 0 29.25 29.25">
              <g id="Icon_ionic-ios-close-circle-outline" data-name="Icon ionic-ios-close-circle-outline" transform="translate(-3.375 -3.375)">
                <path
                  id="Path_21"
                  data-name="Path 21"
                  d="M23.295,21.705,19.589,18l3.705-3.705a1.124,1.124,0,0,0-1.589-1.589L18,16.411l-3.705-3.705a1.124,1.124,0,0,0-1.589,1.589L16.411,18l-3.705,3.705a1.086,1.086,0,0,0,0,1.589,1.116,1.116,0,0,0,1.589,0L18,19.589l3.705,3.705a1.129,1.129,0,0,0,1.589,0A1.116,1.116,0,0,0,23.295,21.705Z"
                />
                <path
                  id="Path_22"
                  data-name="Path 22"
                  d="M18,5.344A12.651,12.651,0,1,1,9.049,9.049,12.573,12.573,0,0,1,18,5.344m0-1.969A14.625,14.625,0,1,0,32.625,18,14.623,14.623,0,0,0,18,3.375Z"
                />
              </g>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default Input;
